import React from 'react';
import MediaQuery from 'react-responsive'
import './styles/Footer.scss'

const Footer = ({sectionCurrently, positionCurrently, setSectionCurrently, setPositionCurrently, Section, Position, responsive}) => {

  const scroll = () =>{
    return false;
  }

  const redirect = (section) => {
    const elementoDestino = document.getElementById(section);
    elementoDestino.scrollIntoView({ behavior: 'smooth' });
  }
  const handleRedirectWsp = () => {
    const url = 'https://wa.me/+17867467873';
    window.open(url, '_blank');
  };

  const handleRedirectApp = () => {
    const url = 'https://apps.apple.com/us/app/karta-app/id6502294163?l=es-MX';
    window.open(url, '_blank');
  };

  const handleCardAgreement = () => {
    const url = 'https://www.conkarta.com/docs/Card_member_agreements_us.html';
    window.open(url, '_blank');
  };
  const handlePrivacy = () => {
    const url = 'https://www.conkarta.com/docs/privacy_policy.html';
    window.open(url, '_blank');
  };
  const handleTerms = () => {
    const url = 'https://www.conkarta.com/docs/terms_of_use.html';
    window.open(url, '_blank');
  };
  const handleSecurity = () => {
    const url = 'https://www.conkarta.com/docs/security_center.html';
    window.open(url, '_blank');
  };

  const handleX = () => {

  };

  const handleLinkedin = () => {

  };

  const handleInstagram = () => {

  };

  const mx = "footer-section fade-in-animation-f disposition-column justify-center align-center ";
  const mm = "footer-section-m fade-in-animation-f disposition-column justify-center align-center ";

  const footerText1 = "The Karta VISA Infinite Card and the VISA Signature Card are issued by Third National, pursuant to a license from VISA. VISA is a registered trademark of VISA International Service Association. All other trademarks and service marks belong to their respective owners.";
  const footerText2 = "The Karta Prepaid VISA cards are issued by Lead Bank, Member FDIC, pursuant to a license from VISA USA Inc. Banking services offered through the Karta Prepaid Card are provided by Lead Bank, and are subject to the terms of a cardholder agreement. Title Labs Inc. DBA Karta is a technology services provider and program manager of the card program.";
  const footerText3 = "Funds in your Karta account will be held or transferred to Lead Bank, an FDIC-insured institution.";
  const footerText4 = "Our payment services are powered by Wise, a registered Money Services Business (MSB) with FinCEN. Wise is not a bank and is not FDIC-insured. In some states, it operates as a service provider for Community Federal Savings Bank, an FDIC-insured institution. Transfers are subject to Wise’s terms, fees, and processing times. By using our services, you agree to Wise’s policies. More details at Wise’s official website.";
  const footerText5 = "Our VAT tax reclaim services are provided in partnership with Revenir, a fintech specializing in automated tax recovery. Using AI and machine learning, Revenir streamlines VAT refunds on eligible purchases. By using this service, you agree to Revenir’s terms, fees, and processing times. More details at Revenir’s official website.";

  return (
    <>
      <MediaQuery minWidth={900}>
        <footer className = { `${mx} ${scroll() ? "fade-out-animation" : ""}`}>
          <div className="first-row disposition-row justify-between align-center">
            <div className="logo-section disposition-column justify-start align-start">
              <img src = "assets/Footer/Logo-Karta-white.png" className = "logo" alt = "Logo" onClick={() => redirect(Section.Section1)}></img>
            </div>
            <div className="qr-section disposition-row justify-around align-center">  
              <img src = "assets/Footer/QR.png" className = "qr-img" alt = "QR"></img>        
              <div className="disposition-column justify-start align-start">
                <p className = "text-1">Download the Karta App</p>
                <p className = "text-2">Scan for download</p>
              </div>
            </div>          
          </div>
          
          <div className="second-row disposition-row justify-start align-start">
            <div className="second-row-elements disposition-row justify-between align-start">
              <div className="element-column disposition-column justify-center align-start">
                <p className = "text-1">For you</p>
                <p className = "text-2 link" onClick={() => redirect("section-5")}>Credit limit</p>
                <p className = "text-2 link" onClick={() => redirect("section-3")}>Card benefits</p>
              </div> 
              <div className="element-column disposition-column justify-center align-start">
                <p className = "text-1">Karta</p>
                <p className = "text-2 link" onClick={() => redirect("section-9")}>Frequently Asked Questions</p>
              </div> 
              <div className="element-column disposition-column justify-center align-start">
                <p className = "text-1">Contact Us</p>
                <p className = "text-2 link" onClick={handleRedirectWsp}>+1 (786) 746-7873</p>
              </div> 
            </div>
          </div>
          <div className="contact-terms-section second-row disposition-row justify-between align-center">
            <div className="terms second-row-elements disposition-row">
              <p className='text-terms link' onClick={handleCardAgreement}>Card member agreement</p>
              <p className='text-terms link' onClick={handlePrivacy}>Privacy</p>
              <p className='text-terms link' onClick={handleTerms}>Terms of Use</p>
              <p className='text-terms link' onClick={handleSecurity}>Security Center</p>
            </div>
            <div className="contact-links">
              <img src="assets/Footer/x.svg" alt="x_social" onClick={handleX} id="x-link" className='text-terms link'></img>
              <img src="assets/Footer/linked-in.svg" alt="linkedin_social" onClick={handleLinkedin} id="linkedin-link" className='text-terms link'></img>
              <img src="assets/Footer/instagram.svg" alt="instagram_social" onClick={handleInstagram} id="instagram-link" className='text-terms link'></img>
            </div>
          </div>
          <hr className = "line"></hr>
          <div className="fourth-row disposition-column justify-start align-start">
            <p className = "text-3">{footerText1}</p>
            <br/>
            {/* <p className = "text-3">{footerText2}</p>
            <br/> */}
            {/* <p className = "text-3">{footerText3}</p>
            <br/> */}
            <p className = "text-3">{footerText4}</p>
            <br/>
            <p className = "text-3">{footerText5}</p>
          </div>
        </footer>
      </MediaQuery>
      <MediaQuery maxWidth={900}>
        <footer className = { `${mm} ${scroll() ? "fade-out-animation" : ""}`}>
          <div className="first-row disposition-column justify-between align-start">
            <div className="logo-section disposition-column justify-start align-start">
              <img src = "assets/Footer/Logo-Karta-white.png" className = "logo" alt = "Logo" onClick={() => redirect(Section.Section1)}></img>
            </div>
            <div className="qr-section disposition-row justify-around align-center">  
              <img src = "assets/Footer/app-store.png" className = "app-img" alt = "App" onClick = {handleRedirectApp}></img>        
            </div>          
          </div>
          <div className="second-row disposition-row justify-start align-start">
            <div className="second-row-elements disposition-column justify-between align-start">
              <div className="element-column disposition-column justify-center align-start">
                <p className = "text-1">For you</p>
                <p className = "text-2 link" onClick={() => redirect("section-5")}>Credit limit</p>
                <p className = "text-2 link" onClick={() => redirect("section-4")}>Card benefits</p>
              </div> 
              <div className="element-column disposition-column justify-center align-start">
                <p className = "text-1">Karta</p>
                <p className = "text-2 link" onClick={() => redirect("section-9")}>Frequently Asked Questions</p>
              </div> 
              <div className="element-column disposition-column justify-center align-start">
                <p className = "text-1">Contact Us</p>
                <p className = "text-2 link" onClick={handleRedirectWsp}>+1 (786) 746-7873</p>
              </div> 
            </div>
          </div>
          <div className="contact-terms-section second-row disposition-column align-center">
            <div className="terms second-row-elements disposition-row">
              <p className='text-terms link' onClick={handleCardAgreement}>Card member agreement</p>
              <p className='text-terms link' onClick={handlePrivacy}>Privacy</p>
            </div>
            <div className="terms second-row-elements disposition-row">
              <p className='text-terms link' onClick={handleTerms}>Terms of Use</p>
              <p className='text-terms link' onClick={handleSecurity}>Security Center</p>
            </div>
          </div>
          <div className="third-row disposition-row justify-between align-center">
            <div className='justify-center align-center'>
              <img src="assets/Footer/x.svg" alt="x_social" onClick={handleX} id="x-link" className='text-terms link'></img>
              <img src="assets/Footer/linked-in.svg" alt="linkedin_social" onClick={handleLinkedin} id="linkedin-link" className='text-terms link'></img>
              <img src="assets/Footer/instagram.svg" alt="instagram_social" onClick={handleInstagram} id="instagram-link" className='text-terms link'></img>
            </div>
            <div className="elements-third-row disposition-row justify-center align-center">
              <img src = "assets/Footer/language-white.png" className = "language-img" alt = "Language"></img>
              <p className = "text-1">English</p>
            </div> 
          </div>
          <hr className = "line"></hr>
          <div className="fourth-row disposition-column justify-start align-start">
            <p className = "text-3">{footerText1}</p>
            <br/>
            {/* <p className = "text-3">{footerText2}</p>
            <br/> */}
            {/* <p className = "text-3">{footerText3}</p>
            <br/> */}
            <p className = "text-3">{footerText4}</p>
            <br/>
            <p className = "text-3">{footerText5}</p>
          </div>
        </footer>
      </MediaQuery>
    </>
  ); 
};

export default Footer;
